module.exports = __webpack_public_path__ + "media/images/2-quart-55808b9600a61510bbd2a894243fa7c9.png";